// <copyright file="auth-constants.ts" company="BD">
// Copyright (c) BD. All rights reserved.
// Created: 02/10/2026 by Sumanth Satheesh
// </copyright>

import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { AuthTokenStore } from "../../shared/stores/auth-token-store";
import { isUsableToken } from "./auth-constants";

/**
 * Functional Auth Guard for protecting routes.
 * Checks if user has a valid access token before allowing navigation.
 * Redirects to login page if not authenticated.
 *
 * @returns true if authenticated, UrlTree redirect to login if not
 */
export const authGuard: CanActivateFn = (): boolean | UrlTree => {
  const authTokenStore = inject(AuthTokenStore);
  const router = inject(Router);

  const token = authTokenStore.getAccessToken();

  if (isUsableToken(token)) {
    return true;
  }

  // No valid token - clear any stale data and redirect to login
  authTokenStore.clear();
  return router.createUrlTree(["/login"]);
};

/**
 * Guard to prevent authenticated users from accessing login page.
 * Redirects to main application if already authenticated.
 *
 * @returns true if not authenticated, UrlTree redirect to mobileupgradeportal if authenticated
 */
export const noAuthGuard: CanActivateFn = (): boolean | UrlTree => {
  const authTokenStore = inject(AuthTokenStore);
  const router = inject(Router);

  const token = authTokenStore.getAccessToken();

  if (isUsableToken(token)) {
    // User is already authenticated, redirect to main page
    return router.createUrlTree(["/mobileupgradeportal"]);
  }

  return true;
};
